module.exports = __webpack_public_path__ + "media/assets/X-thick-white.svg";


//////////////////
// WEBPACK FOOTER
// ./src/media/assets/X-thick-white.svg
// module id = 24
// module chunks = 0